import React from 'react'
import { ConfigProvider} from 'antd';
import esES from 'antd/lib/locale/es_ES'; // Importar el idioma español
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
// import Panel from './pages/Panel';

import Login from './pages/Login';
import Index from './pages/Index';

import { GoogleOAuthProvider } from '@react-oauth/google';
import Panel from './pages/Panel';
import AlumnosPorCarrera from './pages/AlumnosPorCarrera';
import AlumnosPublico from './pages/AlumnosPublico';
import CarrerasPublico from './pages/CarrerasPublico';

// En este archivo se encuentran todas las rutas

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Login/>,
      //errorElement: <ErrorElement/>
    },

    {
      path: "/inicio",
      element: <Panel componente={<Index/>}/>
    },

    {
      path: "/carrera/:pk_carrera",
      element: <Panel componente={<AlumnosPorCarrera/>}/>
    },
    {
      path: "/carreraspublico",
      element: <CarrerasPublico/>
    },
    {
      path: "/alumnospublico/:pk_carrera",
      element: <AlumnosPublico/>
    },
    

  ]);

  return (

<ConfigProvider locale={esES}>

 <GoogleOAuthProvider clientId='547596419142-b5a5i76iodh5fa6htt6ps31o2jkj05vu.apps.googleusercontent.com'>
<RouterProvider router={router} />
</GoogleOAuthProvider>

</ConfigProvider>

    )
}

export default App